import React from 'react'
import './Termsandconditions.css'

const TermsAndConditions = () => {
    return (
        <div className="legal-page">
            <div className="legal-container">
                <h1 className="legal-title">Terms and Conditions</h1>
                <p className="legal-updated">Last updated: June 2026</p>

                <p className="legal-intro">
                    Welcome to Jenitas. By accessing our website and placing an order, you agree to be
                    bound by the following terms and conditions. Please read them carefully before using
                    our services.
                </p>

                <section className="legal-section">
                    <h2>1. General</h2>
                    <p>
                        These terms and conditions govern your use of the Jenitas online store
                        (<strong>jenitas.lk</strong>) and apply to all transactions made through the site.
                        Jenitas is based in Bandarawela, Sri Lanka. By using this website, you confirm
                        that you are at least 18 years of age or are accessing the site under the
                        supervision of a parent or legal guardian.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>2. Products</h2>
                    <p>
                        We make every effort to display product colours, sizes, and descriptions as
                        accurately as possible. However, we cannot guarantee that your device screen
                        accurately reflects the exact colours of our products. Sizes may vary slightly
                        between products — please refer to the size guide provided on each product page.
                    </p>
                    <p>
                        We reserve the right to discontinue any product at any time. All products are
                        subject to availability.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>3. Pricing</h2>
                    <p>
                        All prices are listed in Sri Lankan Rupees (LKR / Rs.) and are inclusive of
                        applicable taxes. We reserve the right to change prices at any time without
                        prior notice. The price displayed at the time of your order placement is the
                        price you will be charged.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>4. Orders and Payment</h2>
                    <p>
                        Placing an order does not constitute a binding contract until payment is confirmed.
                        Orders are confirmed only after we receive and verify your bank transfer payment slip
                        via WhatsApp. Currently, we accept payment via bank transfer only.
                    </p>
                    <p>
                        When making a bank transfer, please include your <strong>Order ID</strong> in the
                        payment reference or remark field. Send your payment slip along with your Order ID
                        to our WhatsApp to complete your order. We reserve the right to cancel any order
                        for which payment is not received within 48 hours of placement.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>5. Delivery</h2>
                    <p>
                        A shipping fee is charged per order. The current rate is displayed at
                    checkout before you confirm your order. We are not responsible for delays
                    caused by courier services, natural disasters, or other events outside
                    our control.
                    </p>
                    <p>
                        Once your order is dispatched, you will be notified via WhatsApp with tracking
                        information where available.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>6. Returns and Refunds</h2>
                    <p>We accept returns under the following conditions:</p>
                    <ul>
                        <li>The return request must be made within <strong>7 days</strong> of receiving your order</li>
                        <li>Items must be <strong>unused</strong> and in their original condition</li>
                        <li>All original <strong>tags must be attached</strong></li>
                        <li>The original <strong>purchase bill/receipt must be presented</strong></li>
                        <li>Items must have <strong>no damage, stains, or alterations</strong></li>
                    </ul>
                    <p>
                        Items that do not meet the above conditions will not be accepted for return.
                        Refunds will be processed within 7 business days of receiving the returned item.
                        Return shipping costs are the responsibility of the customer unless the item
                        received was defective or incorrect.
                    </p>
                    <p>
                        To initiate a return, please contact us at{' '}
                        <a href="mailto:jenitas@gmail.com">jenitas@gmail.com</a> with your Order ID
                        and reason for return.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>7. User Accounts</h2>
                    <p>
                        When you create an account on our website, you are responsible for maintaining
                        the confidentiality of your login credentials. You agree to notify us immediately
                        of any unauthorised use of your account. We reserve the right to terminate
                        accounts that violate these terms.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>8. Intellectual Property</h2>
                    <p>
                        All content on this website — including images, text, logos, and design — is the
                        property of Jenitas and may not be reproduced, distributed, or used without our
                        prior written permission.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>9. Limitation of Liability</h2>
                    <p>
                        Jenitas shall not be liable for any indirect, incidental, or consequential damages
                        arising from the use of our website or products. Our liability is limited to the
                        value of the order placed.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>10. Governing Law</h2>
                    <p>
                        These terms and conditions are governed by the laws of Sri Lanka. Any disputes
                        arising from the use of this website or purchase of our products shall be subject
                        to the jurisdiction of the courts of Bandarawela, Sri Lanka.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>11. Changes to Terms</h2>
                    <p>
                        We reserve the right to update these terms and conditions at any time. Changes
                        will be posted on this page with an updated date. Continued use of the website
                        after any changes constitutes your acceptance of the new terms.
                    </p>
                </section>

                <section className="legal-section">
                    <h2>12. Contact Us</h2>
                    <p>
                        If you have any questions about these Terms and Conditions, please contact us:
                    </p>
                    <ul>
                        <li>Email: <a href="mailto:jenitas@gmail.com">jenitas@gmail.com</a></li>
                        <li>Location: Bandarawela, Sri Lanka</li>
                    </ul>
                </section>
            </div>
        </div>
    )
}

export default TermsAndConditions